export default __webpack_public_path__ + "static/снимок-экрана-2021-07-22-в-14.55.17-0abc7369d177b8976675789953085ab0.png";